import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { Skeleton } from "../Skeleton";
export const ColorPickerSwatch = (props) => {
    const [Swatch, setSwatch] = useState(undefined);
    useEffect(() => {
        if (typeof window !== "undefined") {
            import("@uiw/react-color").then((module) => {
                setSwatch(module.Swatch);
            });
        }
    }, []);
    return Swatch ? (_jsx(Swatch, { style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            width: "100%",
            gap: 8,
        }, rectProps: {
            style: {
                borderRadius: 4,
                margin: 0,
                width: 18,
                height: 18,
            },
        }, ...props })) : (_jsx(Skeleton, { height: 5, sx: { borderRadius: (theme) => theme.radius.default } }));
};
//# sourceMappingURL=ColorPickerSwatch.js.map